import { useState } from 'react';

const faqData = [
  {
    q: '91免费看片app安全吗？会不会有病毒？',
    a: '91免费看片的app所有版本均经过多重安全检测，不含病毒、木马或恶意代码。我们建议用户从本站官方渠道下载91免费软件，避免第三方网站可能携带的捆绑软件或篡改版本。下载后可使用手机自带安全工具进行扫描验证。',
  },
  {
    q: '91免费软件需要付费吗？有隐藏收费吗？',
    a: '91免费看片软件完全免费使用，无任何隐藏收费项目。我们通过广告合作维持运营，不会向用户收取任何费用。免费看片软件安装后即可观看全部内容，没有VIP会员墙或付费解锁机制。',
  },
  {
    q: '苹果手机怎么安装91免费客户端的app？',
    a: 'iOS用户可通过本站提供的企业签名链接直接安装，无需越狱也无需App Store。安装后需在「设置 > 通用 > VPN与设备管理」中信任企业证书即可正常使用。详细图文教程请查看专题索引中的安装指南。',
  },
  {
    q: '91免费看片支持哪些设备和系统？',
    a: '91免费看片的app全面支持Android 6.0+、iOS 12+、Windows 7/10/11以及macOS 11+。同一账号可在手机、平板、电脑间无缝切换，观看记录和收藏自动同步。安卓和苹果端推荐使用91免费客户端获得最佳体验。',
  },
  {
    q: '播放卡顿怎么办？如何提升看片流畅度？',
    a: '播放卡顿通常与网络环境或设备性能有关。建议：1) 切换WiFi或4G/5G网络；2) 在播放器设置中调低画质；3) 关闭后台不必要应用释放内存；4) 检查91免费看片软件是否为最新版本。如问题持续，可在联系我们页面反馈。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">常见问答</h2>
            <p className="mt-2 text-sm text-foreground-500">关于91免费看片软件的常见问题解答</p>
          </div>

          <div className="space-y-3">
            {faqData.map((item, i) => (
              <div
                key={i}
                className={`rounded-xl border transition-all ${
                  openIndex === i
                    ? 'bg-background-50 border-primary-200'
                    : 'bg-background-50 border-background-200/70 hover:border-background-300'
                }`}
              >
                <button
                  className="w-full flex items-center justify-between gap-4 p-4 text-left cursor-pointer"
                  onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
                >
                  <h3 className="text-sm font-semibold text-foreground-900 pr-2">{item.q}</h3>
                  <i
                    className={`ri-arrow-down-s-line text-foreground-400 flex-shrink-0 transition-transform duration-300 ${
                      openIndex === i ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === i ? 'max-h-96 pb-4 px-4' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}